<template>
	<div @click="saveData">test{{msg}}</div>
</template>

<script>
import {ajax} from 'jquery'

export default{
	name: 'test',
	data() {
		return {
			msg: 'ok'
		}
	},
	created() {
		console.log(location.href.split('@')[1])
	},
	methods: {
		saveData() {
			let that = this;

			ajax({
				type: 'post',
				url: that.$store.state.Host+'/v/communications',
				data: {communication:{speaker:'留言者', content:'问答提问没问题。', message_id: 1}},
				success: function(res) {
					console.log(res);
				}
			});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/Test.vue